module.exports = __webpack_public_path__ + "img/btn--expert-v2.9b7a986e.svg";